import { workPool } from '@wochitnpm/helpers';

/**
 * generate `previewResultData` for social assets that has crop effect
 */

/** @namespace workPool.job.cropSocialAsset */
export default workPool.define(
  'cropSocialAsset',
  {
    getContext() {
      return {
        assetId: this.options.asset.id,
      };
    },

    beforeRun(asset) {
      app.Vue.$$set(asset, {
        // data source
        previewResultData: null,
        // progress relevant
        _previewOp: 'create',
        _previewStep: 0,
        _previewStartTime: Date.now(),
      });
    },

    run() {
      const asset = this.options.asset;
      const programmer = this.options.programmer;

      this.beforeRun(asset);

      let duration = programmer.configInitialInfoGfxDT;
      if (app.assetType.isSOCIALFRAGMENT(asset)) {
        duration = asset.endTime - asset.startTime;
      }

      const postData =
        app.namespace.Controller.AssetController.serializeAsset(asset);
      // prd preview should only contain crop values, if any.
      if (!_.isEmpty(postData.agd)) {
        postData.agd = _.pick(postData.agd, ['scale', 'offset']);
      }

      Object.assign(postData, {
        // TODO: check why to bring timeline entities during social PRD?
        displayStartTime: 0,
        displayDuration: duration,
        displayEndTime: duration,

        volumeControl: {
          video: 1,
          bgMusic: null,
          narration: null,
        },
      });

      app.realTimePreviewController
        .addTrackToPreviewQueue({
          delay: 0,
          visualTrack: postData,
          silent: false,
          type: app.RealtimePreviewType.VIDEO,
          source: this.type, // TODO: find usecase (was 'assetModel')
        })
        .then((rtpModel) => {
          if (rtpModel.isDone()) {
            this.onDone(rtpModel);
          } else if (rtpModel.isFailed()) {
            this.onFailure();
          } else {
            rtpModel.on('change:status change:_lastTouch', () => {
              if (rtpModel.isDone()) {
                this.onDone(rtpModel);
              } else if (rtpModel.isFailed()) {
                this.onFailure();
              }
            });
          }
        })
        .fail(() => {
          this.onFailure();
        });
    },

    onDone(rtpModel) {
      const asset = this.options.asset;
      const rtp = rtpModel.get('realTimePreviewResultData');
      app.prependHttpAcrossObject(rtp);

      app.Vue.$$set(asset, {
        previewResultData: rtp,
        _previewOp: 'done',
      });

      this.$emit({ asset });
      this.finish();
    },

    onFailure() {
      const asset = this.options.asset;

      app.Vue.$$set(asset, {
        previewResultData: null,
        _previewOp: 'fail',
      });

      this.$emit({ error: true, asset });
      this.abort();
    },
  },
  {
    // static

    isNeeded(asset) {
      const relevantAsset =
        app.assetType.isSOCIAL(asset) || app.assetType.isSOCIALFRAGMENT(asset);
      const running = workPool.has({
        type: this.type,
        context: (jc) => jc.assetId === asset.id,
      });

      return relevantAsset && !running;
    },

    execute({ asset, programmer }) {
      const isNeeded = this.isNeeded(asset);
      isNeeded && workPool.add(new this({ asset, programmer }));
      return isNeeded;
    },

    updateTimelineTrack: function ({ asset, visualTrack }) {
      if (visualTrack) {
        visualTrack.previewResultData = asset.previewResultData;
      }
    },
  }
);
